import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface EnterpriseValuesRecord {
  symbol: string;
  date: string;
  stockPrice: number;
  numberOfShares: number;
  marketCapitalization: number;
  minusCashAndCashEquivalents: number;
  addTotalDebt: number;
  enterpriseValue: number;
}

export function useCompanyEnterpriseValues(
  ticker: string,
  limit?: number,
  period?: 'annual' | 'quarter'
) {
  return useQuery<EnterpriseValuesRecord[], Error>({
    queryKey: ["companyEnterpriseValues", ticker, limit, period],
    queryFn: async () => {
      const params: any = { ticker };
      if (limit) {
        params.limit = limit.toString();
      }
      if (period) {
        params.period = period;
      }

      const { data } = await api.get<EnterpriseValuesRecord[]>("/company-enterprise-values", {
        params,
      });
      return data;
    },
    enabled: !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 2.5 * 60 * 1000, // 2.5 minutes for fresh data
    retry: (failureCount, error) => {
      // Don't retry on 404s - legitimately means no enterprise values data exists
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any)?.response?.status === 404) {
        return false;
      }
      // Retry other errors (500s, network issues) max 2 times
      return failureCount < 2;
    },
  });
}